/* eslint-disable react-hooks/exhaustive-deps */
import { Button, VbzDivider } from '@smiles/voebiz-ui-kit';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import useFilterData from '../../hooks/useFilterData';
import useModalCheckBoxEngaged from '../../hooks/useModalCheckBoxEngaged';
import CalendarMui from '../CalendarMui';
import Checkbox from '../Checkbox';
import DrawerModal from '../DrawerModal';
import { getOnlyDayByDate } from '../../utils/getOnlyDayByDate';
import CheckboxAvailable from '../CheckboxAvailable';

interface Props {
  isOpen?: boolean;
  toggleModal(isOpen: boolean): void;
}

const ResponseModal: React.FC<Props> = ({ isOpen = false, toggleModal }) => {
  const { setSelectedStartDate, setSelectedEndDate } = useFilterData();
  const {
    setFilterButtonPressed,
    setSelectedContractedPlan,
    setSelectedAvailablePlan,
    selectedStartDate,
    selectedEndDate,
    setStartRowNum,
    setLoading,
  } = useFilterData();
  const { getValue: getValueEngaged } = useModalCheckBoxEngaged();
  const { getValueAvailable: getValueAvailableEngaged } = useModalCheckBoxEngaged();

  const [contractedPlanValue, setContractedPlanValue] = useState([]);
  const [availablePlanValue, setAvailablePlanValue] = useState([]);

  const [setUncheckBoxContracted] = useState(false);
  const [setUncheckBoxAvailable] = useState(false);

  const [startInclusionDate, setStartInclusionDate] = useState<Dayjs | null>(null);
  const [endInclusionDate, setEndInclusionDate] = useState<Dayjs | null>(null);

  const hasAnyFilter = useMemo(() => {
    if (contractedPlanValue.length > 0 || availablePlanValue.length > 0 || startInclusionDate || endInclusionDate) {
      return true;
    }

    return false;
  }, [contractedPlanValue, availablePlanValue, startInclusionDate, endInclusionDate]);

  const filterPlansButtonPressed = () => {
    getValueEngaged(contractedPlanValue);
    getValueAvailableEngaged(availablePlanValue);
    setSelectedContractedPlan(contractedPlanValue);
    setSelectedAvailablePlan(availablePlanValue);
    setFilterButtonPressed(true);
    setStartRowNum(0);
    toggleModal(false);
    setSelectedStartDate(startInclusionDate);
    setSelectedEndDate(endInclusionDate);
    setLoading(true);
  };

  useEffect(() => {
    selectedStartDate ? setStartInclusionDate(selectedStartDate) : '';
    selectedEndDate ? setEndInclusionDate(selectedEndDate) : '';
  }, []);

  return (
    <DrawerModal
      id="modalId"
      open={isOpen}
      anchor="right"
      onClose={() => {
        toggleModal(false);
      }}
    >
      <div className="texts">
        <div>
          <h3 className="titlePlansFilter">Filtros</h3>
          <p className="titlePlansModal">Data da inclusão do perfil</p>
          <p className="subtitlePlansModal">Selecione um período de busca:</p>
          <div className="calenderfilter">
            <CalendarMui
              label="De"
              views={['day', 'month', 'year']}
              format="DD MM YYYY"
              value={getOnlyDayByDate(startInclusionDate)}
              onChange={(newValue) => setStartInclusionDate(newValue)}
            />
            <CalendarMui
              label="Até"
              views={['day', 'month', 'year']}
              format="DD MM YYYY"
              value={getOnlyDayByDate(endInclusionDate)}
              onChange={(newValue) => setEndInclusionDate(newValue)}
            />
          </div>
        </div>
        <VbzDivider className="modaldivider" />
        <div>
          <p className="titlePlansModal">Planos disponíveis</p>
          <p className="subtitlePlansModal">Selecione os planos disponíveis que deseja encontrar nessa busca</p>
          <CheckboxAvailable
            engagedAvailable
            setAvailablePlanValue={setAvailablePlanValue}
            setUncheckBoxAvailable={setUncheckBoxAvailable}
          />
        </div>
        <div>
          <p className="titlePlansModal">Plano contratado</p>
          <p className="subtitlePlansModal">Selecione os planos contratados que deseja encontrar nessa busca</p>
          <Checkbox
            engaged
            setContractedPlanValue={setContractedPlanValue}
            setUncheckBoxContracted={setUncheckBoxContracted}
          />
        </div>
        <Button
          disabled={!hasAnyFilter}
          onClick={() => filterPlansButtonPressed()}
          className="buttonmodalFilter"
          data-testid="filter"
        >
          <span>Filtrar</span>
        </Button>
        <div className="mt-3 buttonBackModal" onClick={() => toggleModal(false)}>
          <span style={{ position: 'relative', top: '8px', cursor: 'pointer' }}>Voltar</span>
          <hr style={{ width: '42px', border: '1px solid #999999', borderRadius: '100px', position: 'absolute' }} />
        </div>
      </div>
    </DrawerModal>
  );
};

export default ResponseModal;
